<script>
import swal from "sweetalert";
import {therapistsService} from "@/services";
import {mapActions} from "vuex";

export default {
  name: "HasloCertyfikatu",
  data() {
    return {
      loading: false,
      haslo: null,
      save_on_server: false
    };
  },
  props: ["visible"],
  methods: {
    ...mapActions("account", ["getpermissions"]),
    closeForm() {
      this.$emit("close");
    },
    handleSubmit() {
      if(!this.haslo)
      {
        this.showError('Hasło nie może być puste')
        return
      }
      if(this.save_on_server)
      {
        therapistsService.SaveCertPassword(this.haslo).then(() => {
          this.getpermissions()
          this.$emit('save',this.haslo)
        }).catch(err => {
          if (
              err.response != null &&
              err.response.data != null &&
              err.response.data.error != null
          ) {
            this.showError(err.response.data.error.message)
          } else {
            this.showError("Błąd zapisu hasła certyfikatu.");
          }
        })
      }
      else
      {
        this.$emit('save',this.haslo)
      }
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

          }
      )
    },
  },
  computed: {
    showModal: {
      get: function() {
        return this.visible
      },
      set: function(value) {
        if(!value){
          this.$emit('close')
        }

      }
    }
  },
}
</script>

<template>
  <v-dialog v-model="showModal" max-width="600px" persistent>
    <v-card>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Wprowadź hasło certyfikatu i spróbuj ponownie</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container>
          <v-row>
            <v-col>
              <v-text-field label="Hasło" v-model="haslo" type="password"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox v-model="save_on_server" label="Zapamiętaj hasło na stałe"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm" color="error">Zamknij</v-btn>
        <v-btn color="success"   @click="handleSubmit">Zapisz</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>